import React, { Component } from 'react';
import TextSection from '../TextSection/TextSection';
import QuoteSection from '../QuoteSection/QuoteSection';
import MobileImage from '../MobileImage/MobileImage';
import ImageSection from '../ImageSection/ImageSection';
import siteContent from '../../data/SiteContent';
import Style from './ContentSection.css';

class ContentSection extends Component {
	render() {
		const item = siteContent[this.props.secID];
		return (
			<section style={Style.ContentSection} className={`container content-section ` + item.align}>
				<div className="text-quote ">
					<TextSection textData={item.textCont} alignItem={item.align}></TextSection>
					<MobileImage imageData={item.imageContMobile}></MobileImage>
					<QuoteSection quoteData={item.quoteCont} alignItem={item.align}></QuoteSection>
				</div>
				<div className="img-area">
					<ImageSection imageData={item.imageCont}></ImageSection>
				</div>
			</section>
		);
	}
}

export default ContentSection;
